<div nxModalContent class="customizeFotTheActive-template">
    <h3 nxHeadline="subsection-medium">
      {{ 'offer.addOns.customize.active-modal.title' | translate }}
    </h3>
    <div class="customizeFotTheActive-template_wrapper">
      <ng-container [ngSwitch]="customizeStatus$ | async">
        <app-loader *ngSwitchCase="apiState.pending"></app-loader>
        <app-error *ngSwitchCase="apiState.error"></app-error>
        <ng-container *ngSwitchDefault>
          <h4 nxHeadline="subsection-small" class="customizeFotTheActive-template_subheader">
            {{ 'offer.addOns.customize.active-modal.description' | translate }}
          </h4>
          <form [formGroup]="form">
            <app-dynamic-input-array
              [formGroup]="form"
              name="customizeFotTheActiveIncluded"
              inputType="checkbox"
              label="offer.addOns.customize.active-modal.label"
              [labelArgs]="(labelArgs$ | async) || []"
            ></app-dynamic-input-array>
            <button nxButton type="submit" (click)="handleSubmit()" [disabled]="form.invalid" class="customizeFotTheActive-template_btn">
              {{ 'offer.addOns.customize.active-modal.button' | translate }}
            </button>
          </form>
        </ng-container>
      </ng-container>
    </div>
  </div>
  